import { getApiV1Url } from '@/config/api'

/** 프로젝트 lookup API의 project `type` (mashup enum) */
export type ProjectType = 'STANDALONE' | 'PLATFORM' | 'BRAND' | 'STANDARD' | string

/** GET /api/v1/projects/{projectCode}/lookup 응답 `data` */
export interface ProjectLookupData {
  id: number
  accountCode: string
  code: string
  status: string
  type: ProjectType
  parentCode?: string
  name: string
  logo?: string
  description?: string
  createdBy?: string
  createdAt?: string
  updatedBy?: string
  updatedAt?: string
  settings?: Record<string, unknown>
}

interface ApiResponse<T> {
  data?: T
  errors?: {
    error?: Array<{ code?: number; target?: string; message?: string }>
  }
}

/**
 * GET /api/v1/projects/{projectCode}/lookup
 */
export async function getProjectLookup(projectCode: string): Promise<ProjectLookupData> {
  const code = projectCode.trim()
  const url = getApiV1Url(`/projects/${encodeURIComponent(code)}/lookup`)
  const response = await fetch(url, { method: 'GET' })
  const json: ApiResponse<ProjectLookupData> = await response.json()

  if (!response.ok) {
    const message =
      json?.errors?.error?.[0]?.message ?? `프로젝트 정보 조회 실패 (${response.status})`
    throw new Error(message)
  }

  if (json.data == null) {
    throw new Error('프로젝트 정보를 불러올 수 없습니다.')
  }

  return json.data
}
